export const ROUTE_PATH = '/storeBonuses';
